//----产品扩展属性的变更选择----------
function CustomExtendOptionChange(element, event) {
    var parentElement=element.parentNode;
    var preElement=element.previousElementSibling;
    preElement.click();
    var selectValue=preElement.value;
    parentElement.querySelector(".select_option_value").innerHTML=selectValue;
}